import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

interface ScreenShellProps {
  readonly children: ReactNode;
  /** Zusätzliche Klassen am Innen-Container (Default: `max-w-sm`). */
  readonly innerClassName?: string;
  /**
   * Stabiler Diskriminator für die `<AnimatePresence>`-Reconciliation
   * (typischerweise `${screenKey}-${tenantId}`); wird ans `motion.div`
   * gereicht.
   */
  readonly motionKey?: string;
}

const SHELL_CLASSES = 'flex flex-1 flex-col items-center justify-center px-6 pb-8 pt-6';
const DEFAULT_INNER = 'w-full max-w-sm';
const TRANSITION = { duration: 0.25, ease: 'easeOut' as const };
const INITIAL = { opacity: 0, y: 8 };
const ANIMATE = { opacity: 1, y: 0 };
const EXIT = { opacity: 0, y: -8 };

/**
 * Animierter Wrapper für jeden Screen-Inhalt. Übernimmt das Lovable-Inset
 * (`px-6 pb-8 pt-6`) und die Eintritts-/Austritts-Animation; eingebettet in
 * ein `<AnimatePresence mode="wait">` in `app.tsx`.
 *
 * Reduced-Motion respektiert framer-motion automatisch — die globale
 * `prefers-reduced-motion`-CSS-Regel deckt zusätzlich klassisches CSS ab.
 */
export function ScreenShell(props: ScreenShellProps): JSX.Element {
  const innerClassName = props.innerClassName ?? DEFAULT_INNER;
  return (
    <motion.div
      key={props.motionKey}
      className={SHELL_CLASSES}
      initial={INITIAL}
      animate={ANIMATE}
      exit={EXIT}
      transition={TRANSITION}
    >
      <div className={innerClassName}>{props.children}</div>
    </motion.div>
  );
}
